import { render } from "./index.vue?vue&type=template&id=e4d97e32&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=e4d97e32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4d97e32"],['__file',"src/views/SwitchMembership/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e4d97e32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e4d97e32', __exports__)) {
    api.reload('e4d97e32', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=e4d97e32&scoped=true", () => {
    api.rerender('e4d97e32', render)
  })

}


export default __exports__